// src/constants.js

export const VAPI_PUBLIC_KEY = "7996e4b2-f72d-464b-9cfa-34e2c1abdd86";
